import { render, staticRenderFns } from "./developerInformation.vue?vue&type=template&id=98c58d76&scoped=true&"
import script from "./developerInformation.vue?vue&type=script&lang=js&"
export * from "./developerInformation.vue?vue&type=script&lang=js&"
import style0 from "./developerInformation.vue?vue&type=style&index=0&id=98c58d76&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c58d76",
  null
  
)

export default component.exports